import _fetch from '.'

export async function getProfile(options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users/me`
    return _fetch(url, options)
}

export async function updateProfile(options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users/me`
    return _fetch(url, options)
}

export async function updateAdminProfile(id, options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users/admins/${id}`
    return _fetch(url, options)
}

export async function deleteAccount(options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users/me`
    return _fetch(url, options)
}

export async function getUsers(options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users`
    return _fetch(url, options)
}
